<template>
<ValidationObserver ref="observer">
  <form ref="add_client_master_form" @submit.prevent="addClientMaster">

    <md-card>

      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Add Client Master
        </h4>
      </md-card-header> -->
      <md-card-content>

        <!-- <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Client No.(Read)<span style="color:red"> *</span>
          </label>
          <div class="md-layout-item">
            <validation-provider rules="clientno" v-slot="{ errors }">
              <md-field class="md-invalid">
                <md-input v-model="client_no" readonly/>
                <validation-error :errors="apiValidationErrors.client_no" />
              </md-field>
                <span>{{ errors[0] }}</span>
             </validation-provider>
          </div>
        </div> -->
        <div class="md-layout md-glutter">
          <div class="md-layout-item md-small-size-100">
              <!-- <label class="md-layout-item md-size-15 md-form-label">
                <span style="color:brown">Name</span><span style="color:red"> *</span>
              </label> -->
              <validation-provider rules="name" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Name</label>
                  <md-input v-model="client_name" required/>
                  <validation-error :errors="apiValidationErrors.client_name" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <!-- <label class="md-layout-item md-size-15 md-form-label">
                <span style="color:brown">Phone</span>
              </label> -->
              <validation-provider rules="digits_between:10,14" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label>Phone Number</label>
                <md-input v-model="client_phone" type="text" v-on:keypress="NumbersOnly"/>
                <validation-error :errors="apiValidationErrors.client_phone" />
              <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
          </div>
          <div class="md-layout-item md-small-size-100">
              <!-- <label class="md-layout-item md-size-15 md-form-label">
                <span style="color:brown">Email</span>
              </label> -->
              <md-field class="md-invalid">
                <label>Email</label>
                <md-input v-model="client_email" type="email" />
                <validation-error :errors="apiValidationErrors.client_email" />
              </md-field>
            </div>
        </div>
        
        <div class="md-layout md-glutter">
          <div class="md-layout-item md-small-size-100">
              <!-- <label class="md-layout-item md-size-15 md-form-label">
                <span style="color:brown">Address</span>
              </label> -->
                <md-field class="md-invalid" style="margin-bottom:20px;">
                  <label>Address</label>
                  <md-textarea  v-model="client_address" md-counter="100" maxlength="100" md-autogrow/>
                  <md-avatar >
                  <md-icon style="color:blue;">report</md-icon>
                  <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
                </md-avatar>
                  <validation-error :errors="apiValidationErrors.client_address" />
                </md-field>
            </div>
        </div>
      </md-card-content>

      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
        <md-button class="md-dense" @click="backtoList">
          Go to List
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</ValidationObserver>
  
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend , validate, localize , ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { min, max, numeric } from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en.json";
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';

Vue.use(VueSweetalert2);

localize({
      en
  });

  extend("min", min);
  extend("max", max);
  extend("numeric", numeric);

// membuat input phone number dengan min dan max digit
  extend('digits_between', {
    async validate(value, { min, max }) {
          const res = await validate(value, `numeric|min:${min}|max:${max}`,)
              return res.valid;
    },
    params: ['min', 'max'],
    message: 'Phone must be between {min} and {max} digits'
  });

// mengirim pesan error ketika required field tidak diisi
extend('name', {
  ...required,
  message: 'Client Name field is required'
});
extend('clientno', {
  ...required,
  message: 'Client No. field is required'
});
  
  export default {
     name: "add-client-master",

    props: {
      data: Object
    },

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

    data: () => ({
      // client_no: null,
      client_name: null,
      client_phone: null,
      client_email: null,
      client_address: null
    }),

    // created() {
    //   this.getLastNo();
    // },

   

    methods: {
      // async getLastNo(){
      //      await this.$store.dispatch("workshop_client_master/last_no")
      //      this.client_no =  await this.$store.getters["workshop_client_master/client_master"]
           
      // },


      // fungsi untuk tombol direct ke list client master
      backtoList(id) {
      this.$router.replace({ name: 'List Client Master' })
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

     // validasi menggunakan sweetalert  sebelum menambah data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
    Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.addClientMaster()
          }
        });
    },


    // fungsi add data
      async addClientMaster() {
       

        const data = {
          type: "workshop_client_masters",
          // client_no: this.client_no,
          client_name: this.client_name,
          client_phone: this.client_phone,
          client_email: this.client_email,
          client_address: this.client_address
        }


        try {
        await this.$store.dispatch("workshop_client_master/add", data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        await this.$router.replace({name: 'List Client Master'});
      } catch (e) {
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      }
    }
  };
</script>
